import {css} from '@emotion/react';
import styled from '@emotion/styled';

type Props = {
  padding?: number;
};

export const BannerStack = styled.div<Props>(
  ({padding = 0}) => css`
    box-sizing: border-box;
    display: grid;
    row-gap: 24px;
    align-content: flex-start;
    height: 100%;
    padding: ${`${padding}px`} 0;
  `
);
